import { useEffect, useState } from 'react'
import { setMobileCardsCount, setTabletCardsCount } from 'utils/helpers'

type VisibleCardsProps = {
  clientWidth: number
  cardsInRow: number
  rowDirection: string
  tvChannelCard: boolean
  withSpecialCell?: boolean
}

export const useVisibleCards = ({
  clientWidth,
  cardsInRow,
  rowDirection,
  tvChannelCard,
  withSpecialCell,
}: VisibleCardsProps): number => {
  const [visibleCards, setVisibleCards] = useState(0)

  useEffect(() => {
    if (clientWidth) {
      if (clientWidth < 600) {
        setMobileCardsCount({
          clientWidth,
          cardsInRow,
          rowDirection,
          setVisibleCards,
          tvChannelCard,
        })
      }
      if (clientWidth >= 600 && clientWidth < 1240) {
        setTabletCardsCount({
          clientWidth,
          cardsInRow,
          rowDirection,
          setVisibleCards,
          tvChannelCard,
          withSpecialCell,
        })
      }
      if (clientWidth >= 1240 && clientWidth < 1640) {
        setVisibleCards(cardsInRow)
      }

      if (clientWidth >= 1640 && clientWidth < 1920) {
        setVisibleCards(cardsInRow + 1)
      }
      if (clientWidth >= 1920) {
        setVisibleCards(cardsInRow + 2)
      }
    }
  }, [clientWidth, cardsInRow, rowDirection])

  return visibleCards
}
